import React from 'react';

import { Flex } from '@chakra-ui/react';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const ObjectiveKrWeightageCell = ({ data }) => {
  const { weightage } = data ?? {};

  return (
    <Flex height="100%" position="relative" alignItems="center">
      <TextBodyMedium>{weightage}%</TextBodyMedium>
    </Flex>
  );
};

export { ObjectiveKrWeightageCell };
